<template>
	<div>
		<toolbar v-if="$store.userRole != 'Light'">
			<router-link v-if="fromInvoices" to="/financial/invoices" class="btn btn-link">
				<i class="fa fa-caret-left fa-2x"></i>
				<h2>Invoices</h2>
			</router-link>
			<router-link v-else-if="activeTab == 'dashboard' || $route.params.id == 'new' || $route.params.id == 'new-quote'" to="/services" class="btn btn-link">
				<i class="fa fa-caret-left fa-2x"></i>
				<h2>Services</h2>
			</router-link>
			<router-link v-else-if="'slug' in $store.service" :to="'/service/'+$store.service.slug+'/dashboard'" class="btn btn-link">
				<i class="fa fa-caret-left fa-2x"></i>
				<h2>Dashboard</h2>
			</router-link>

			<div class="controls">
				<slot></slot>

				<template v-if="extraActionMenuItemsStart.length == 0 && $route.params.id != 'new' && $route.params.id != 'new-quote'">
						
					<button class="btn btn-primary" v-on:click="notifyCustomerETA">
						<i class="fa fa-sms"></i>
						Notify Customer of ETA
					</button>

					<button class="btn btn-primary" v-on:click="doCompanyForm" :disabled="!('id' in $store.service) || $store.company.is_freemium == 1">
						<i v-if="$store.company.is_freemium == 1" class="fa fa-lock"></i>
						<i v-else class="fa fa-fw fa-clipboard-check"></i>
						Do Company Form
					</button>

					<button v-if="hasModulePermWrite('Service Quotes/Invoices') && !quoteRecord && extraActionMenuItemsStart.length == 0"
						class="btn btn-success"
						:disabled="!serviceStatusIncompleteGroup || isFreemiumUser"
						:title="!serviceStatusIncompleteGroup ? 'You cannot create a change quote for a completed job' : 'Click to create a change quote'"
						v-on:click="createChangeQuote">

						<i class="fa" :class="isFreemiumUser ? 'fa-lock' : 'fa-plus'"></i>
						Change Quote
					</button>

					<button v-if="hasModulePermWrite('Service Quotes/Invoices') && $store.service.status == 'Dispatched'" class="btn btn-primary" v-on:click="revertToQuoteStatus">
						<i class="fa fa-undo-alt"></i>
						Revert to Quote
					</button>

					<button v-if="extraActionMenuItemsStart.length == 0"
						class="btn btn-success" v-on:click="newMessage">
						<i class="fa fa-plus"></i>
						<i class="fa fa-envelope"></i>
					</button>
				</template>
				
				<nav-tabs v-if="$route.params.id != 'new' && $route.params.id != 'new-quote'" 
					:tabs="tabs"
					:mobile-breakpoint="mobileBreakpoint"
					:extra-action-menu-items-start="extraActionMenuItemsStart"
					addon-apps-location="Service Record"
					:addon-apps-link="'/service/'+$store.service.slug+'/apps'"
					v-on:buttonClick="actionItemClick">
				</nav-tabs>
			</div>

		</toolbar>

		<job-delete-alert v-if="$store.service.deleted == 1" job-api-resource="Service"></job-delete-alert>
		<archived-alert v-if="!hideArchiveAlert"></archived-alert>

		<div v-if="$store.service.status == 'Canceled'" class="alert alert-danger job-status-alert">
			<i class="fa fa-ban"></i>
			This service was canceled:
			<strong>{{$store.service.canceled_reason}}</strong>
		</div>

		<div v-if="isQuote" class="alert alert-info job-status-alert">
			This service is in <strong>Quote</strong> status. <router-link v-if="hasModulePermWrite('Services')" to="details/details">Change status</router-link>
		</div>

		<template v-if="showTitleWidget">
			<h2 v-if="$route.params.id == 'new' || $route.params.id == 'new-quote'">
				New <!--{{isNewEmergency ? 'Emergency' : ''}}--> Service 
			</h2> 
			<div v-else class="card title-widget mb-2" :class="titleWidgetWidth">

				<div class="card-body" style="padding: 8px;">
					<button v-if="!$store.clockedIn && $store.service.archived != 1 && $store.service.status != 'Completed' && $store.service.status != 'Quote'" 
						class="btn btn-success float-right"
						v-on:click="clockInToService">
						<i class="fa fa-clock"></i>
						Clock In to Service
					</button>
					<div style="clear: both;"></div>
					<div class="d-flex justify-content-between align-items-center flex-wrap">
						<div class="flex-grow-1">
							<h2>
								{{serviceHeadingTitle}}
								<template v-if="serviceHeadingSmall">
									<br>
									<small class="text-muted">{{serviceHeadingSmall}}</small>
								</template>
							</h2>
							
						</div>
						<service-status-label :status="$store.service.status"></service-status-label>
					</div>
					<div v-if="showDetailsInTitle" class="d-flex flex-row justify-content-between flex-wrap mt-2">
						<div>
							<button class="btn btn-light" v-on:click="contactModalVisible = true">
								<i class="fa fa-project-diagram"></i>
								See Contacts
							</button>
							<button class="btn btn-light ml-1" v-on:click="openWorkHistoryModal">
								<i class="fa fa-history"></i>
								See Work History
							</button>
						</div>
						<div>
							<button v-if="!mapVisible" class="btn btn-light" type="button" v-on:click="mapVisible = true">
								<i class="fa fa-map"></i>
								View Map
							</button>
							<button v-else class="btn btn-light" type="button" v-on:click="mapVisible = false">
								Hide Map
								<i class="fa fa-times"></i>
							</button>
						</div>
					</div>
					<job-map
						v-if="mapVisible && $store.service.lat && $store.service.long"
						:job-location="{
							lat: +$store.service.lat,
							lng: +$store.service.long
						}"
						:map-zoom="10"
						:check-in-tolerance="+$store.service.check_in_tolerance">
					</job-map>
					<div class="last-edited-info">
						<hr>
						<div v-if="$store.service.UpdatedBy" class="text-muted mb-1" style="width: 50%">
							Last edited by {{ $store.service.UpdatedBy.first_name }} {{ $store.service.UpdatedBy.last_name }} @ {{ formatDateTimeToLocal($store.service.updated_at,'full-date-time') }}
						</div>
					</div>
				</div>
			</div>
			<!--<heading-widget v-else
				:title="serviceHeadingTitle"
				:small="serviceHeadingSmall"
				:width="titleWidgetWidth"
				class="d-flex flex-row flex-wrap justify-content-between">

				<div v-if="$store.service.UpdatedBy" class="text-muted mb-1" style="width: 50%">
					Last edited by {{ $store.service.UpdatedBy.first_name }} {{ $store.service.UpdatedBy.last_name }} @ {{ $store.service.updated_at }}
				</div>

			</heading-widget>-->
		</template>

		<modal-dialog :modal-visible="contactModalVisible"
			title="Service Contacts"
			v-on:closeModal="contactModalVisible = false"
			cancel-button-text="Done"
			modal-size="modal-lg"
			:submit-visible="false">

			<div class="row mb-1">
				<div v-if="$store.service.Customer" class="col-sm-6"> 
					<div><strong>Customer</strong></div>
					<div>{{ $store.service.Customer.name }}</div>
				</div>
				<div v-if="$store.service.customer_po" class="col-sm-6"> 
					<div><strong>Customer PO</strong></div>
					<div>{{ $store.service.customer_po }}</div>
				</div>
			</div>
			<div v-if="$store.service.Customer" class="row mb-2">
				<div class="col-sm-6"> 
					<div><strong>Customer Phone</strong></div>
					<div><a :href="'tel:'+$store.service.Customer.phone">{{ $store.service.Customer.phone }}</a></div>
				</div>
				<div class="col-sm-6"> 
					<div><strong>Customer Email</strong></div>
					<div><a :href="'mailto:'+$store.service.Customer.email">{{ $store.service.Customer.email }}</a></div>
				</div>
			</div>

			<h4>Contacts</h4>

			<contact-table 
				:readonly="true"
				record-type="service" 
				:contacts="$store.service.ServiceContact" 
				:record-id="$store.service.id">
			</contact-table>

		</modal-dialog>

		<modal-dialog :modal-visible="workHistoryModal.visible"
			title="Work History"
			v-on:closeModal="workHistoryModal.visible = false"
			cancel-button-text="Done"
			:submit-visible="false">

			<div v-if="workHistoryModal.loading" class="text-center py-3">
				<i class="fa fa-spinner fa-spin"></i> Loading services...
			</div>
			<table-list v-else-if="mutatedServicesForHistory.length"
				:fields="[
					{label: 'Service', key: 'serviceLink', type: 'link'},
					{label: 'Work Description', key: 'workDescription'},
					{label: 'Date Completed', key: 'dateCompleted'}
				]"
				:records="mutatedServicesForHistory"
				:hide-record-count="true"
				:sortable="false">
			</table-list>
			<div v-else class="text-muted">No services found for this customer.</div>

		</modal-dialog>

		<modal-dialog :modal-visible="etaNoticeModal.visible"
			title="Notify Customer of ETA"
			v-on:closeModal="etaNoticeModal.visible = false"
			v-on:confirm="confirmNotifyCustomerETA">

			Would you like to send an SMS message to the customer notifying them of your estimated time of arrival?

			<field label="Contact"
				col-class="col-sm-4"
				:params="{type: 'select',options: contactOptions}"
				v-model="etaNoticeModal.recipientContactId">
			</field>

			<field label="ETA (min)"
				col-class="col-sm-4"
				:params="{type:'number',min:1,step: 1}"
				v-model="etaNoticeModal.estimatedETA">
				(Estimated ETA based on your current location)
			</field>

		</modal-dialog>

		<modal-dialog :modal-visible="changeQuoteTemplatePromptVisible"
			title="Change Quote"
			confirm-button-text="Yes"
			cancel-button-text="No"
			v-on:closeModal="onChangeQuoteTemplatePromptNo"
			v-on:confirm="onChangeQuoteTemplatePromptYes">

			Would you like to copy from a Quote Template?

		</modal-dialog>

		<service-quote-template-picker-modal
			:modal-visible="changeQuoteTemplatePickerVisible"
			:quote-templates="quoteTemplates"
			v-on:closeModal="changeQuoteTemplatePickerVisible = false"
			v-on:templateSelected="createChangeQuoteFromTemplate">
		</service-quote-template-picker-modal>

		<div v-if="$store.userRole == 'Light' && $store.service && $store.service.slug" class="service-light-nav">
			<light-nav-buttons
				:module-base-url="'/service/'+$store.service.slug+'/'"
				job-type="service">
			</light-nav-buttons>
		</div>

	</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"
import LightNavButtons from "@/layout_fragments/LightNavButtons"
import HeadingWidget from '@/components/HeadingWidget'
import ArchivedAlert from './ArchivedAlert'
import JobMap from "@/components/JobMap"
import ServiceMixins from "@/mixins/ServiceMixins.js"
import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ServiceQuoteTemplateMixins from "@/mixins/ServiceQuoteTemplateMixins.js"
import ModalDialog from "@/components/ModalDialog"
import ContactTable from "@/components/super_components/ContactTable"
import JobDeleteAlert from "@/components/super_components/JobDeleteAlert"
import Field from "@/components/Field"
import ServiceStatusLabel from "@/components/ServiceStatusLabel"
import ServiceQuoteTemplatePickerModal from "@/components/super_components/ServiceQuoteTemplatePickerModal"
import TableList from "@/components/TableList"

	export default {
		name: "ServiceToolbar",
		components: {
			Toolbar,
			NavTabs,
			LightNavButtons,
			HeadingWidget,
			ArchivedAlert,
			JobMap,
			ModalDialog,
			ContactTable,
			JobDeleteAlert,
			Field,
			ServiceStatusLabel,
			ServiceQuoteTemplatePickerModal,
			TableList
		},
		mixins: [ServiceMixins,InvoiceMixins,ServiceQuoteTemplateMixins],
		props: ["heading","showTitleWidget","titleWidgetWidth","hideArchiveAlert","showDetailsInTitle","activeTab"],
		data() {
			return {
				mobileBreakpoint: 1024,
				mapVisible: false,
				contactModalVisible: false,
				workHistoryModal: {
					visible: false,
					loading: false,
					services: []
				},
				etaNoticeModal: {
					visible: false,
					estimatedETA: null,
					recipientPhone: null
				},
				changeQuoteTemplatePromptVisible: false,
				quoteTemplates: null,
				changeQuoteTemplatePickerVisible: false
			}
		},
		computed: {
			extraActionMenuItemsStart() {
				let items = []
				if (window.innerWidth < this.mobileBreakpoint && this.$route.params.id != 'new' && this.$route.params.id != 'new-quote') {

					let disabled = !("id" in this.$store.service) || !this.$store.service.id

					if (this.$store.service.status == 'Dispatched') {
						items.push({
							label: "Notify Customer of ETA",
							icon: "fa-sms",
							click: "notifyCustomerETA",
							disabled
						})
					}

					items.push({label: "Do Company Form",icon:"fa-clipboard-check",click:"doCompanyForm",disabled})

					items.push({
						label: "Message Thread",
						icon: "fa-plus",
						click: "newMessage",
						disabled
					})

					if (this.hasModulePermWrite('Service Quotes/Invoices')) {

						if (!this.quoteRecord) {
							items.push({
								label: "Change Quote",
								icon: "fa-plus",
								click: "createChangeQuote",
								disabled
							})
						}
						if (this.$store.service.status == 'Dispatched') {
							items.push({
								label: "Revert to Quote",
								icon: "fa-undo-alt",
								click: "revertToQuoteStatus",
								disabled
							})
						}
					}
				}
				return items
			},
			tabs() {
				let vm = this

				let numFiles = ""
				if (this.$store.service.ServiceFile && this.$store.service.ServiceFile.length > 0) 
					numFiles = " ("+this.$store.service.ServiceFile.length+")"

				//filter if quote
				let tabs = []

				tabs = [
					{
						label: "Dashboard",
						path: "/service/"+this.$route.params.id+"/dashboard",
						icon: "fa-tachometer-alt",
						freemiumTier: true
					},
					{
						label: "Details",
						path: "/service/"+this.$route.params.id+"/details",
						icon: "fa-list",
						freemiumTier: true
					},

					{
						label: "Worksheet",
						path: "/service/"+this.$route.params.id+"/worksheet",
						icon: "fa-wrench",
						skipIfQuote: true
					},
					{
						label: "Forms",
						path: "/service/"+this.$route.params.id+"/forms",
						icon: "fa-clipboard-check"
					},
					{
						label: "Files"+numFiles,
						path: "/service/"+this.$route.params.id+"/files",
						icon: "fa-file-image"
					},
					{
						label: "Messages",
						path: "/service/"+this.$route.params.id+"/messages",
						icon: "fa-envelope",
						more: true,
						freemiumTier: true
					},
					{
						label: "Locates",
						path: "/service/"+this.$route.params.id+"/locates",
						icon: "fa-map-pin",
						more: true
					},
					{
						label: "Time Logs",
						path: "/service/"+this.$route.params.id+"/time-logs",
						icon: "fa-clock",
						more: true,
						freemiumTier: true
					},
					{
						label: "Expenses",
						path: "/service/"+this.$route.params.id+"/expenses",
						icon: "fa-receipt",
						more: true
					},
					{
						label: "Purchase Orders",
						path: "/service/"+this.$route.params.id+"/purchase-orders",
						icon: "fa-file-invoice",
						modulePermRequired: ["Purchase Orders"],
						more: true
					},
					{
						label: "Invoice",
						path: "/service/"+this.$route.params.id+"/invoice",
						icon: "fa-file-invoice-dollar",
						// modulePermRequired: ["Service Quotes/Invoices"] //open to anyone, but we'll make sure further down that they have "Write Quotes/Invoices role perm"
					},
					{
						label: "Report",
						path: "/service/"+this.$route.params.id+"/report",
						icon: "fa-chart-pie",
						modulePermRequired: ["Service Quotes/Invoices","Services"],
						skipIfQuote: true
					}
				]

				let hasPerm = false
				if ("JobPersonnelRole" in vm.$store.service && vm.$store.service.JobPersonnelRole && "User" in vm.$store.service && vm.$store.service.User) {
					let rolesOnJobWithWriteInvoicePerms = vm.$store.service.JobPersonnelRole.filter(role => role.write_invoices == 1)

					let userRoles = vm.$store.service.User.filter(user => user.user_id == vm.$store.userDetails.id)

					userRoles.forEach(user => {
						let matchingRole = rolesOnJobWithWriteInvoicePerms.find(role => role.id == user.personnel_role_id)

						if (matchingRole)
							hasPerm = true
					})
				}

				if (this.$store.service.status == "Quote") 
					tabs = tabs.filter(tab => !("skipIfQuote" in tab) || !tab.skipIfQuote)

				if (this.quoteRecord || this.$store.service.status == "Quote") {
					let quoteLabel = "Quote"
					if (this.hasChangeQuoteRecord)
						quoteLabel = "Change Quote"

					tabs.splice(2,0,{
						label: quoteLabel,
						path: "/service/"+this.$route.params.id+"/quote",
						icon: "fa-file-invoice-dollar",
						//modulePermRequired: ["Service Quotes/Invoices"]
					})
				}			

				let modulePerms = this.getUserModulePerms()
				if (!("Services" in modulePerms)) {
					modulePerms.Services = {
						write: false
					}
				}

				return tabs.filter(tab => {
					if (tab.label == "Details") {
						if (vm.getUserRoleType() == "Admin" || modulePerms.Services.write)
							return true
						else 
							return false
					}

					if (tab.label == "Invoice") {
						//if user doesn't have "Service Quotes/Invoices" module perm, not a role based "Write Quotes/Invoices" perm, filter it out

						if (!vm.hasModulePermRead("Service Quotes/Invoices")) {
							if (!hasPerm)
								return false
						}


						//check if service has invoice record on it
						let theInvoice = false, theQuote = false
						if ("ServiceInvoice" in vm.$store.service && vm.$store.service.ServiceInvoice) {
							theInvoice = vm.$store.service.ServiceInvoice.find(inv => inv.is_quote == 0)
							theQuote = vm.$store.service.ServiceInvoice.find(inv => inv.is_quote == 1)
						}

						//make sure service status is completed or above, or quote is accepted
						if (theQuote && theQuote.quote_status == 'Accepted')
							return true

						if (vm.dateIsEmpty(vm.$store.service.completed) && !theInvoice)
							return false
						else
							return true
					}
					else if (tab.label == "Quote" && !vm.hasModulePermRead("Service Quotes/Invoices") && !hasPerm)
						return false
					
					return true
				})

			},
			fromInvoices() {
				if (this.$store.lastRoute == "/financial/invoices")
					return true
				else
					return false
			},
			contactOptions() {
				let vm = this

				if (this.$route.params.id == 'new')
					return [] 

				if (!("ServiceContact" in this.$store.service) || !this.$store.service.ServiceContact)
					return []

				let contacts = this.$store.service.ServiceContact
					.filter(contact => "Contact" in contact && contact.Contact.phone)
					.map(contact => {
						return {
							text: contact.Contact.name + " (" + contact.Contact.phone + ")",
							value: contact.Contact.id
						}
					})

				let customerOption = false
				if (this.$store.service && "Customer" in this.$store.service && this.$store.service.Customer) {
					customerOption = {
						text: this.$store.service.Customer.name + " (" + this.$store.service.Customer.phone + ")",
						value: this.$store.service.Customer.id
					}

					return [
						customerOption,
						...contacts
					]
				}
				else
					return contacts
				
			},
			mutatedServicesForHistory() {
				let vm = this

				return vm.workHistoryModal.services.map(service => {
					let workDescription = service.description ? service.description.replace(/(<([^>]+)>)/gi, "") : ""
					if (workDescription.length > 50)
						workDescription = workDescription.substring(0, 50) + "..."

					return {
						id: service.id,
						serviceLink: {
							text: service.job_num + ": " + service.job_name,
							link: "/service/" + service.slug + "/dashboard"
						},
						workDescription,
						dateCompleted: service.completed ? vm.formatDateTimeToLocal(service.completed, "full-date") : ""
					}
				})
			}
		},
		methods: {
			doCompanyForm() {
				this.$bus.$emit("doCompanyForm",{service_id: this.$store.service.id})
			},
			actionItemClick(item) {
				this[item.click]()
			},
			newMessage() {
				this.$bus.$emit("newThread","service",this.$store.service.id)
			},
			revertToQuoteStatus() {
				let vm = this

				this.postData("Service/save",{id: this.$store.service.id, status: "Quote"}).then(response => {
					vm.$router.push("/service/"+vm.$store.service.slug+"/quote")
				})
			},
			notifyCustomerETA() {
				this.etaNoticeModal.visible = true

				let vm = this

				let position = this.getLocation().then(response => {

					let origin_lat = response.lat
					let origin_long = response.lng

					vm.getJSON("Service/get-estimated-drive-time",{id: this.$store.service.id, origin_lat, origin_long}).then(response => {
						if (response.success) {
							vm.etaNoticeModal.estimatedETA = Math.round(+response.data.distance)
						}
					})
				})

				if (!("ServiceContact" in this.$store.service) || !this.$store.service.ServiceContact || this.$store.service.ServiceContact.length == 0)
					this.fetchContacts()

				vm.etaNoticeModal.recipientContactId = this.$store.service.customer_id
			},
			confirmNotifyCustomerETA() {
				let vm = this

				let payload = {
					id: this.$store.service.id, 
					eta_minutes: this.etaNoticeModal.estimatedETA, 
					recipient_contact_id: this.etaNoticeModal.recipientContactId
				}

				this.postData("Service/notify-customer-eta",payload,true).then(response => {
					if (response.success) {
						vm.etaNoticeModal.visible = false
						vm.alertSuccess("SMS message sent!")
					}
				})
			},
			onChangeQuoteTemplatePromptNo() {
				this.changeQuoteTemplatePromptVisible = false
				this.createChangeQuoteSubmit()
			},
			onChangeQuoteTemplatePromptYes() {
				this.changeQuoteTemplatePromptVisible = false
				this.changeQuoteTemplatePickerVisible = true
			},
			createChangeQuoteSubmit() {
				let vm = this

				let payload = {
					service_id: this.$store.service.id,
					service_contract_id: this.$store.contract_id,
					customer_id: this.$store.service.customer_id,
					is_change_quote: 1,
					is_quote: 1
				}

				this.postData("ServiceInvoice/save",payload,true).then(response => {
					if (response.success)
						vm.$router.push("/service/"+vm.$store.service.slug+"/quote")
				})
			},
			createChangeQuoteFromTemplate(fullTemplate) {
				let vm = this

				let payload = {
					service_id: this.$store.service.id,
					service_contract_id: this.$store.contract_id,
					customer_id: this.$store.service.customer_id,
					is_change_quote: 1,
					is_quote: 1,
					skipQBOPush: true
				}

				if (fullTemplate.work_to_do)
					payload.work_completed_description = fullTemplate.work_to_do

				if (fullTemplate.quote_description)
					payload.customer_notes = fullTemplate.quote_description

				payload.applied_sales_tax_json = this.compileDefaultTaxes()

				this.postData("ServiceInvoice/save",payload,true).then(response => {
					if (!response.success)
						return

					let records = vm.buildServiceInvoiceObjectRecordsFromTemplate(fullTemplate,response.record_id)

					if (records.length) {
						let invoiceObjectsPayload = {
							records: JSON.stringify(records)
						}

						vm.postData("ServiceInvoiceObject/save-batch",invoiceObjectsPayload,true).then(objectSaveResponse => {
							if (objectSaveResponse.success)
								vm.$router.push("/service/"+vm.$store.service.slug+"/quote")
						})
					}
					else
						vm.$router.push("/service/"+vm.$store.service.slug+"/quote")
				})
			},
			createChangeQuote() {
				let vm = this

				vm.getJSON("ServiceQuoteTemplate/get").then(response => {
					if (response.success) {
						vm.quoteTemplates = response.data

						if (vm.quoteTemplates.length == 0)
							vm.createChangeQuoteSubmit()
						else
							vm.changeQuoteTemplatePromptVisible = true
					}
					else 
						vm.createChangeQuoteSubmit()
				})
			},
			fetchContacts() {
				let vm = this

				let params = {
					filters: [
						["service_id",this.$store.service.id],
					],
					include: ["Contact"]
				}

				return new Promise((resolve,reject) => {
					vm.getJSON("ServiceContact/get",params).then(response => {
						vm.$store.service.ServiceContact = response.data

						resolve(response)
					})
				})
			},
			openWorkHistoryModal() {
				let vm = this

				vm.workHistoryModal.visible = true
				if (vm.workHistoryModal.services.length == 0)
					vm.fetchServiceHistory()
			},
			fetchServiceHistory() {
				let vm = this

				vm.workHistoryModal.services = []
				vm.workHistoryModal.loading = true

				let params = {
					filters: [
						["customer_id", this.$store.service.customer_id],
						["completed !=",null]
					],
					fields: ["id", "slug", "job_num", "job_name", "description", "completed"],
					orders: [
						["completed","DESC"]
					]
				}

				vm.getJSON("Service/get", params).then(response => {
					vm.workHistoryModal.loading = false
					if (response.success)
						vm.workHistoryModal.services = response.data
				})
			},
		},
		mounted() {
			if (this.$store.userRole == 'Light') {
				let container = this.$el.closest('.container-fluid')
				if (container)
					container.classList.add('service-light')
			}
		},
		beforeDestroy() {
			let container = this.$el.closest('.container-fluid')
			if (container)
				container.classList.remove('service-light')
		}
	}
</script>

<style type="text/css" scoped>
	.title-widget {
		margin: auto;
	}

	.title-widget.lg {
		max-width: 1200px;
	}

	.title-widget.md {
		max-width: 1000px;
	}

	.title-widget.sm {
		max-width: 800px;
	}

	.title-widget.xsm {
		max-width: 600px;
	}

	.service-light-nav {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 20;
		background-color: #fff;
		border-top: 1px solid rgba(15, 23, 42, 0.08);
		box-shadow: 0 -4px 16px rgba(15, 23, 42, 0.06);
		padding: 0.5rem 0.75rem calc(0.5rem + env(safe-area-inset-bottom, 0px));
	}

	@media (max-width: 600px) {
		.last-edited-info {
			display: none;
		}
	}
</style>

<style>
	/* Shared with service page roots that include ServiceToolbar for Light users */
	.container-fluid.service-light {
		padding-bottom: 7.5rem;
		position: relative;
		top: -15px;
	}
</style>